'use strict';

import React from 'react';
import { createItemDetailStore } from '../../redux/store';
import { renderComponent } from '@src/utils/renderer/client-renderer';
import { ItemDetailsHome } from '../../views/item/index';

if (window.APP === 'item-detail') {
    const store = createItemDetailStore(window.REDUX_DATA);

    renderComponent(<ItemDetailsHome />, {
        store,
        enableQueryClient: true,
        useHydrateRoot: true
    });
}
